import { BOOKING_APIS } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

export interface IProfilePinEligibilityData {
  is_pin_eligible: boolean;
  booking_ids: string[];
}

interface IProfilePinEligibilityResponse {
  data?: IProfilePinEligibilityData;
  message?: string;
}

export interface IProfilePinEligibilityResult {
  status: boolean;
  data: IProfilePinEligibilityData | null;
  message?: string;
}

export const useProfilePinEligibilityAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async (userId: string): Promise<IProfilePinEligibilityResult> => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      return await axios
        .get(`${BOOKING_APIS.PROFILE_PIN_ELIGIBILITY.baseURL}${userId}/profile_pin_eligibility/`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IProfilePinEligibilityResponse>) => ({
          status: true,
          data: {
            is_pin_eligible: res?.data?.data?.is_pin_eligible === true,
            booking_ids: res?.data?.data?.booking_ids ?? [],
          },
          message: res?.data?.message,
        }))
        .catch((e: AxiosError) => {
          sendCurl(e.config?.["curlCommand"]);
          const message = (e?.response?.data as any)?.message ?? "Unable to check PIN eligibility";
          return { status: false, data: null, message };
        });
    } catch (e: any) {
      return { status: false, data: null, message: e.message };
    }
  }, []);

  return { execute };
};
